import { useEffect, useState } from 'react';

import { EllipsisVertical } from 'lucide-react';
import { ToggleOptionGroup, ToggleOptionGroupItem, DefaultTooltip, Select } from 'twyne-new.ui';

import { useResponsive, useUtilities } from '@/modules/cms/views/post/components/builder/context';

import { useCraftProp } from '../utils';

export default function PositionProperty() {
  const { device } = useResponsive()
  const { selectedUtilities } = useUtilities()

  return <NativeStyle key={device + selectedUtilities} />
}

function NativeStyle() {
  const { value: appearance, setValue: setAppearance } = useCraftProp('nativeStyle')
  const [arbitrary, setArbitrary] = useState()

  useEffect(() => {
    if (arbitrary === undefined) {
      setArbitrary(appearance && !appearance?.includes('appearance-'))
    }
  }, [appearance, arbitrary, setArbitrary])

  const handleChangeToggle = () => {
    setArbitrary(!arbitrary)
    setAppearance()
  }

  return <>
    <div className='flex gap-1'>
      {arbitrary ? <>
        <Select
          value={appearance}
          onChange={option => setAppearance(option?.value)}
          options={ARBITRARY_OPTIONS}
          clearable
          creatable
          variant='accent'
        />
      </> : <>
        <ToggleOptionGroup className='w-full' size='lg' value={appearance || ''} type='single' onValueChange={setAppearance}>
          <ToggleOptionGroupItem value='appearance-none' className='w-full'>
            <DefaultTooltip content='Remove default browser styling' triggerProps={{ className: 'w-full flex justify-center' }}>
              None
            </DefaultTooltip>
          </ToggleOptionGroupItem>
          <ToggleOptionGroupItem value='appearance-auto' className='w-full'>
            <DefaultTooltip content='Use default browser styling' triggerProps={{ className: 'w-full flex justify-center' }}>
              Auto
            </DefaultTooltip>
          </ToggleOptionGroupItem>
        </ToggleOptionGroup>
      </>}
      <ToggleOptionGroup size='lg' value={arbitrary ? 'show' : ''} type='single' onValueChange={() => handleChangeToggle(!arbitrary)}>
        <ToggleOptionGroupItem value='show'>
          <DefaultTooltip size='left' content={arbitrary ? 'Show predefined options' : 'Show arbitrary options'} triggerProps={{ className: 'w-full flex justify-center' }}>
            <EllipsisVertical size='14' />
          </DefaultTooltip>
        </ToggleOptionGroupItem>
      </ToggleOptionGroup>
    </div>
  </>
}

const ARBITRARY_OPTIONS = [
  { value: 'none', label: 'None' },
  { value: 'auto', label: 'Auto' },
  { value: 'menulist-button', label: 'Menulist Button' },
  { value: 'textfield', label: 'Textfield' },
  { value: 'base-select', label: 'Base Select' },
  { value: 'inherit', label: 'Inherit' },
  { value: 'initial', label: 'Initial' },
  { value: 'revert', label: 'Revert' },
  { value: 'revert-layer', label: 'Revert Layer' },
  { value: 'unset', label: 'Unset' },
  { value: 'button', label: 'Button' },
  { value: 'checkbox', label: 'Checkbox' },
  { value: 'listbox', label: 'Listbox' },
  { value: 'menulist', label: 'Menulist' },
  { value: 'meter', label: 'Meter' },
  { value: 'progress-bar', label: 'Progress Bar' },
  { value: 'push-button', label: 'Push Button' },
  { value: 'radio', label: 'Radio' },
  { value: 'searchfield', label: 'Searchfield' },
  { value: 'slider-horizontal', label: 'Slider Horizontal' },
  { value: 'square-button', label: 'Square Button' },
  { value: 'textarea', label: 'Textarea' },
  { value: 'slider-vertical', label: 'Slider Vertical' },
]
